import React, { useEffect, useState } from 'react';
import { storage } from '../../utils/storage';
import { FaTrashCan } from "react-icons/fa6";
import BottomNav from '../../components/BottomNav/Boomnav';
import './GoalsPage.css';

const GoalsPage = ({ onNavigate }) => {
  const [active, setActive] = useState('goals');
  const handleNavChange = (id) => {
    setActive(id);
    if (onNavigate) onNavigate(id);
  };
  const [showForm, setShowForm] = useState(false);
  const [goalName, setGoalName] = useState("");
  const [goalValue, setGoalValue] = useState("");
  const [goals, setGoals] = useState([]);
  const [saldo, setSaldo] = useState(0);

  const [usuario, setUsuario] = useState(null);
  useEffect(() => {
    // Carrega usuário logado
    const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
    setUsuario(usuarioLogado);
  }, []);

  useEffect(() => {
    // Sempre que o usuário mudar, carrega saldo e metas dele
    if (usuario && usuario.email) {
      if (usuario.saldo !== undefined) {
        setSaldo(Number(usuario.saldo));
      }
      const metasSalvas = localStorage.getItem(`prisma_metas_${usuario.email}`);
      if (metasSalvas) {
        setGoals(JSON.parse(metasSalvas));
      } else {
        setGoals([]);
      }
    }
  }, [usuario]);

  // Salva metas do usuário logado sempre que goals mudar
  useEffect(() => {
    if (usuario && usuario.email) {
      localStorage.setItem(`prisma_metas_${usuario.email}`, JSON.stringify(goals));
    }
  }, [goals, usuario]);

  const handleCreateClick = () => setShowForm(true);
  const handleCancel = () => {
    setShowForm(false);
    setGoalName("");
    setGoalValue("");
  };
  const handleSave = () => {
    if (!goalName || !goalValue || isNaN(Number(goalValue)) || Number(goalValue) <= 0) return;
    const novasMetas = [...goals, { name: goalName, value: Number(goalValue) }];
    setGoals(novasMetas);
    if (usuario && usuario.email) {
      localStorage.setItem(`prisma_metas_${usuario.email}`, JSON.stringify(novasMetas));
    }
    setShowForm(false);
    setGoalName("");
    setGoalValue("");
  };

  return (
    <div className="goals-page" style={{ paddingBottom: 90, background: '#1A1D24', minHeight: '100vh' }}>
      <div style={{ maxWidth: 420, margin: '0 auto', padding: '0 16px 16px 16px' }}>
        <h2 style={{ fontWeight: 800, fontSize: 22, color: '#fff', marginBottom: 18 }}>Gestão de Metas</h2>
        <div style={{ background: '#47526B', borderRadius: 14, border: '1.5px solid #00C689', boxShadow: '0 2px 8px #0001', padding: 18, marginBottom: 18 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ border: '2px solid #00c689', borderRadius: '50%', width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 6 }}>
              <span style={{ width: 10, height: 10, background: '#fff', borderRadius: '50%', display: 'block' }}></span>
            </span>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#fff' }}>Metas Financeiras</div>
              <div style={{ color: '#c0d0e6', fontSize: 14 }}>Defina objetivos e acompanhe seu progresso.</div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 18, marginBottom: 18 }}>
          <div style={{ background: '#47526B', borderRadius: 12, border: '1.5px solid #00C689', flex: 1, textAlign: 'center', padding: '18px 0' }}>
            <div style={{ color: '#c0d0e6', fontWeight: 700, fontSize: 13, marginBottom: 2 }}>ATIVAS</div>
            <div style={{ fontWeight: 900, fontSize: 22, color: '#fff' }}>{goals.length}</div>
          </div>
          <div style={{ background: '#47526B', borderRadius: 12, border: '1.5px solid #00C689', flex: 1, textAlign: 'center', padding: '18px 0' }}>
            <div style={{ color: '#c0d0e6', fontWeight: 700, fontSize: 13, marginBottom: 2 }}>CONCLUÍDO</div>
            <div style={{ fontWeight: 900, fontSize: 22, color: '#00c689' }}>{goals.filter(g => g.concluida).length}</div>
          </div>
        </div>
        {!showForm ? (
          <button
            style={{ width: '100%', background: '#00c689', border: 'none', borderRadius: 12, padding: '18px 0', fontWeight: 700, fontSize: 16, color: '#fff', cursor: 'pointer', marginBottom: 18 }}
            onClick={handleCreateClick}
          >
            + CRIAR NOVA META
          </button>
        ) : (
          <div style={{ background: '#47526B', borderRadius: 12, border: '1.5px solid #00C689', padding: 18, marginBottom: 18 }}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontWeight: 700, color: '#fff', fontSize: 15, display: 'block', marginBottom: 6 }}>Nome da Meta</label>
              <input
                type="text"
                value={goalName}
                onChange={e => setGoalName(e.target.value)}
                placeholder="Digite o nome da meta"
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1.5px solid #c0d0e6', fontSize: 15, marginBottom: 10, background: '#fff', color: '#222' }}
              />
              <label style={{ fontWeight: 700, color: '#fff', fontSize: 15, display: 'block', marginBottom: 6 }}>Valor da Meta</label>
              <input
                type="number"
                value={goalValue}
                onChange={e => setGoalValue(e.target.value)}
                placeholder="Digite o valor da meta"
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1.5px solid #c0d0e6', fontSize: 15, marginBottom: 10, background: '#fff', color: '#222' }}
              />
            </div>
            <div style={{ display: 'flex', gap: 12 }}>
              <button
                onClick={handleSave}
                style={{ flex: 1, background: '#00c689', color: '#fff', fontWeight: 700, fontSize: 16, border: 'none', borderRadius: 8, padding: '12px 0', cursor: 'pointer' }}
              >Salvar</button>
              <button
                onClick={handleCancel}
                style={{ flex: 1, background: '#c0d0e6', color: '#222', fontWeight: 700, fontSize: 16, border: 'none', borderRadius: 8, padding: '12px 0', cursor: 'pointer' }}
              >Cancelar</button>
            </div>
          </div>
        )}
        {/* Lista de metas salvas */}
        {goals.length > 0 && goals.map((goal, idx) => {
          const metaValor = Number(goal.value);
          let percent = 0;
          let concluida = goal.concluida || false;
          if (concluida) {
            percent = 100;
          } else if (metaValor > 0 && saldo > 0) {
            percent = Math.min(100, Math.round((saldo / metaValor) * 100));
            if (percent >= 100) concluida = true;
          }
          return (
            <div key={idx} style={{ background: '#47526B', borderRadius: 12, border: concluida ? '2px solid #00c689' : '1.5px solid #00C689', marginBottom: 14, padding: '10px 18px 14px 18px', position: 'relative' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                <span style={{ fontWeight: 700, color: '#fff', fontSize: 16 }}>{goal.name}</span>
              </div>
              <div style={{ width: '100%', height: 8, background: '#c0d0e6', borderRadius: 6, position: 'relative', marginTop: 6 }}>
                <div style={{ width: `${percent}%`, height: '100%', background: '#00c689', borderRadius: 6, position: 'absolute', left: 0, top: 0, transition: 'width 0.3s' }}></div>
              </div>
              <div style={{ position: 'absolute', top: 8, right: 18, display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ background: concluida ? '#00c689' : '#c0d0e6', color: concluida ? '#fff' : '#222', fontWeight: 700, fontSize: 12, borderRadius: 6, padding: '2px 10px' }}>{concluida ? 'Concluída' : 'Em andamento'}</div>
                {!concluida && (
                  <button onClick={() => {
                    // Marcar como concluída manualmente
                    const novasMetas = goals.map((g, i) => i === idx ? { ...g, concluida: true } : g);
                    setGoals(novasMetas);
                    if (usuario && usuario.email) {
                      localStorage.setItem(`prisma_metas_${usuario.email}`, JSON.stringify(novasMetas));
                    }
                  }} title="Marcar como concluída" style={{ background: '#00c689', border: 'none', color: '#fff', fontWeight: 700, fontSize: 12, borderRadius: 6, padding: '4px 10px', cursor: 'pointer' }}>
                    Concluir
                  </button>
                )}
                <button onClick={() => {
                  const novasMetas = goals.filter((_, i) => i !== idx);
                  setGoals(novasMetas);
                  if (usuario && usuario.email) {
                    localStorage.setItem(`prisma_metas_${usuario.email}`, JSON.stringify(novasMetas));
                  }
                }} title="Excluir meta" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}>
                  <FaTrashCan style={{ color: '#e53e3e', fontSize: 18 }} />
                </button>
              </div>
            </div>
          );
        })}
      </div>
      <BottomNav active={active} onChange={handleNavChange} />
    </div>
  );
};

export default GoalsPage;